import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LocaleContext } from "../../contexts/LocaleContext";
import trip_photo_main from "../../assets/images/trip_photo_main.jpg";
import provider_profile from "../../assets/images/provider_profile.jpg";
import sa_flag from "../../assets/images/sa_flag.jpg";
import { get } from "react-hook-form";
import { tripService } from "../../services/tripService";
import { toast } from "../../services/toastService";
import Loading from "../../components/common/Loading";
import BackButton from "../../components/common/BackButton";
import { urlConfig } from "../../config/baseUrl";
import "../../utils/extensions";
import defaultProfile from "../../assets/images/default-profile.jpg";
import DeleteConfirmation from "../../components/DeleteConfirmation";
import { tripVideoService } from "../../services/tripVideoService";

const TripDetails = () => {
  const { id } = useParams();
  const { t, lang } = useContext(LocaleContext);
  const [data, setData] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [videoId, setVideoId] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getDeatil();
  }, []);
  const getDeatil = async () => {
    try {
      const result = await tripService.getDetail(id);
      if (!result.isSuccess) {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        console.log(result.errors);
        return;
      }
      setData(result.value);
      console.log(result.value);
      setSelectedImage(result.value.mainImage);
    } catch (error) {
      toast.error(t("anErrorOccurredPleaseTryAgainLater"));
      console.log(error);
    }
  };
  const handleDelete = async () => {
    try {
      setLoading(true);
      if (!videoId) {
        toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        console.log("No ID selected for deletion");
        return;
      }

      const response = await tripVideoService.deleteAsync(videoId);
      if (!response.isSuccess) {
        toast.error(t(response.key));
        console.log(response);
        return;
      }
      toast.success(t("recordDeletedSuccessfully"));
      getDeatil();
    } catch (error) {
      toast.error(t("anErrorOccurredPleaseTryAgainLater"));
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  if (!data) return <Loading />;

  return (
    <section className="section-trip-details">
      <div className="default-heading">{t("tripsDashboardAndManagement")}</div>
      <div className="my-card">
        <div className="my-card-header d-flex justify-content-between align-items-center">
          <div className="my-card-header-title">{t("tripDetails")}</div>
          <BackButton />
        </div>
        <div className="my-card-body">
          <div className="trip-card mb-3">
            <div className="row">
              <div className="col-12 col-md-4 p-0">
                <div className="trip-card-title">{data.title[lang]}</div>
              </div>
              <div className="col-12 col-md-8">
                <div className="col-12">
                  <div className="trip-card-items">
                    <div className="trip-card-item">
                      <strong>{t("city")}</strong>
                      <span>{data.city[lang]}</span>
                    </div>
                    <div className="trip-card-item">
                      <strong>{t("category")}</strong>
                      <span>{data.category[lang]}</span>
                    </div>
                    <div className="trip-card-item">
                      <strong>{t("status")}</strong>
                      <span>{data.isActive ? t("active") : t("inActive")}</span>
                    </div>
                    <div className="trip-card-item">
                      <strong>{t("code")}</strong>
                      <span>{data.code}</span>
                    </div>
                    <div className="trip-card-item">
                      <strong>{t("registrationDate")}</strong>
                      <span>{data.registrationDate?.toDate()}</span>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="trip-card-items border-0 justify-content-between align-items-center">
                    <div className="d-flex gap-3">
                      <div className="trip-card-item">
                        <strong>{t("address")}</strong>
                        <span>{data.address[lang]}</span>
                      </div>
                      <div className="trip-card-item">
                        <strong>{t("noOfPeople")}</strong>
                        <span>{data.noOfPeople}</span>
                      </div>
                    </div>
                    <div>
                      {t("startingFrom")} {data.startingPrice} {t("riyal")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="trip-card mb-3">
            <div className="flex-grow-1">
              <div className="trip-photo-title">
                <i className="fas fa-images"></i>
                {t("tripPhotos")} (
                {data.mainImage ? 1 + data.galleryImages.length : 0})
              </div>
              <div className="trip-section">
                <div className="trip-thumbnail-items">
                  <div
                    className="trip-thumbnail-item"
                    onClick={() => setSelectedImage(data.mainImage)}
                  >
                    <div className="trip-thumbnail-box">
                      <img
                        className={`cursor-pointer ${selectedImage === data.mainImage ? "thumbnail-selected" : ""}`}
                        src={`${urlConfig.imageBaseUrl}/${data.mainImage}`}
                        alt="Trip Photo"
                      />
                    </div>
                  </div>
                  {data.galleryImages?.map((item) => (
                    <div
                      className="trip-thumbnail-item"
                      onClick={() => setSelectedImage(item)}
                    >
                      <div className="trip-thumbnail-box">
                        <img
                          className={`cursor-pointer ${selectedImage === item ? "thumbnail-selected" : ""}`}
                          src={`${urlConfig.imageBaseUrl}/${item}`}
                          alt="Trip Photo"
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="trip-photo-main-image-box">
                  <img
                    src={`${urlConfig.imageBaseUrl}/${selectedImage}`}
                    alt="Trip Photo"
                  />
                </div>
              </div>
              <div className="trip-add-section d-none">
                <div className="trip-add-section-btn">
                  <i className="fas fa-plus"></i>
                  <span>{t("addImage")}</span>
                </div>
              </div>
            </div>
          </div>
          {data.isInternational && data.tripDestinations?.length > 0 && (
            <div className="trip-card mb-3 d-block">
              <div className="trip-card-heading">{t("tripDestinations")}</div>

              <div className="trip-destinations">
                {[...data.tripDestinations]
                  .sort((a, b) => a.order - b.order)
                  .map((destination, index) => (
                    <div
                      className="trip-destination-card"
                      key={`${destination.order}-${index}`}
                    >
                      <div className="trip-destination-number">
                        {destination.order}
                      </div>

                      <div className="trip-destination-info">
                        <div className="trip-destination-location">
                          <div className="trip-destination-country">
                            {destination.country?.[lang]}
                          </div>
                          <div className="trip-destination-city">
                            {destination.city?.[lang]}
                          </div>
                        </div>

                        <div className="trip-destination-days">
                          <strong>{destination.days}</strong>
                          <span>{t("days")}</span>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
          <div className="trip-card mb-3 d-block">
            <div className="trip-card-heading">{t("tripDescription")}</div>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="trip-description-item">{data.description}</div>
              </div>
              <div className="col-12 col-md-6">
                <div className="trip-description-item">
                  {data.descriptionEn}
                </div>
              </div>
            </div>
          </div>
          {data.videos?.length > 0 && (
            <div className="trip-card d-block">
              <div className="trip-card-heading">{t("tripVideoManager")}</div>
              <div className="row">
                {data.videos?.map((item) => (
                  <div className="col-12 col-md-4">
                    <div className="trip-video-item">
                      <video width="300" controls preload="metadata">
                        <source
                          src={`${urlConfig.imageBaseUrl}/${item.video}`}
                          type="video/mp4"
                        />
                      </video>
                      <i
                        className="fas fa-times cursor-pointer"
                        onClick={() => setVideoId(item.id)}
                        data-bs-toggle="modal"
                        data-bs-target="#my-modal"
                      ></i>
                    </div>
                  </div>
                ))}
              </div>
              <div className="trip-add-section d-none">
                <div className="trip-add-section-btn">
                  <i className="fas fa-plus"></i>
                  <span>{t("addVideo")}</span>
                </div>
              </div>
            </div>
          )}
          <div className="trip-card mt-3">
            <div className="grid-row">
              <div className="grid-col">
                <div className="trip-details-title">{t("tripDetails")}</div>
              </div>
              <div className="grid-col">
                <div className="trip-details-items">
                  <div className="trip-details-item">
                    <strong>{t("maxNoOfPeople")}</strong>
                    <span>
                      {data.noOfPeople} {t("people")}
                    </span>
                  </div>
                  <div className="trip-details-item">
                    <strong>{t("minimumBooking")}</strong>
                    <span>
                      {data.minimumBooking}{" "}
                      {t(data.packages[0].unit?.toLowerCase())}
                    </span>
                  </div>
                  <div className="trip-details-item">
                    <strong>{t("availableFrom")}</strong>
                    <span>{data.availableFrom?.toTime(lang)}</span>
                  </div>
                </div>
                <div className="trip-details-items border-0 p-0">
                  <div className="trip-details-item">
                    <strong>{t("availableUntil")}</strong>
                    <span>{data.availableTo?.toTime(lang)}</span>
                  </div>
                  <div className="trip-details-item">
                    <strong>{t("creationDate")}</strong>
                    <span>{data.registrationDate?.toDate()}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="trip-card mt-3">
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="trip-provider-information">
                  <div className="trip-provider-profile-layer">
                    <div className="trip-provider-profile">
                      <img
                        src={
                          data.provider.profileImage
                            ? `${urlConfig.imageBaseUrl}/${data.provider.profileImage}`
                            : { defaultProfile }
                        }
                        alt="Provider Profile"
                      />
                    </div>
                  </div>
                  <b>{t("providerInformation")}</b>
                </div>
              </div>
              <div className="col-12 col-md-8">
                <div className="row h-100">
                  <div className="col-12 col-md-12">
                    <div className="trip-provider-items">
                      <div className="trip-provider-item">
                        <strong>{t("fullName")}</strong>
                        <span>{data.provider.fullName}</span>
                      </div>
                      <div className="trip-provider-item">
                        <strong>{t("mobileNumber")}</strong>
                        <span className="trip-provider-mobile-number">
                          {data.provider.phoneCode}
                          <div className="trip-mobile-flag-box">
                            <img src={sa_flag} alt="SA Flag" />
                          </div>
                          {data.provider.phoneNumber}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-12">
                    <div className="trip-provider-items border-0">
                      <div className="trip-provider-item">
                        <strong>{t("email")}</strong>
                        <span>{data.provider.email}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="trip-card mt-3">
            <div className="trip-card-heading">{t("tripPackages")}</div>

            <div className="row g-3">
              {data.packages?.map((item) => {
                const offer = item.offer ?? 0;

                const discountedCost = Math.round(
                  item.cost * (1 - offer / 100),
                );

                return (
                  <div className="col-12 col-md-6" key={item.code}>
                    <div className="trip-package-item">
                      <div className="d-flex justify-content-between align-items-center">
                        <strong>
                          {t("package")}: {item.code}
                        </strong>

                        <div className="text-end">
                          {offer > 0 && (
                            <>
                              <span className="text-decoration-line-through me-2">
                                {item.cost} {t("riyal")}
                              </span>
                              <span className="badge bg-danger me-2">
                                {offer}% {t("discount")}
                              </span>
                            </>
                          )}

                          <strong>
                            {discountedCost} {t("riyal")}
                          </strong>
                        </div>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>{item.name[lang]}</span>
                        <span>
                          {t("status")}: {t("active")}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>{t("tripDetails")}:</span>
                        <span>{t("perUnit")}</span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>
                          {t("numberOf")}: {item.unitNumber}{" "}
                          {t(item.unit?.toLowerCase())}
                        </span>
                        <span>
                          {t("minimum")}: 1 {t("person")}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>
                          {t("maximum")}: {data.noOfPeople} {t("person")}
                        </span>
                        <span>
                          {t("unit")}: {item.unitNumber}{" "}
                          {t(item.unit?.toLowerCase())}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {data.addons?.length > 0 && (
            <div className="trip-card mt-3">
              <div className="trip-card-heading">{t("tripAddons")}</div>

              <div className="row g-3">
                {data.addons.map((item, index) => (
                  <div className="col-12 col-md-6" key={index}>
                    <div className="trip-package-item">
                      <div className="d-flex justify-content-between">
                        <strong>{item.name?.[lang]}</strong>
                        <strong>
                          {item.price} {t("riyal")}
                        </strong>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>
                          {t("category")}: {item.category?.[lang]}
                        </span>

                        <span>
                          {t("stock")}: {item.stock}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {data.coupons?.length > 0 && (
            <div className="trip-card mt-3">
              <div className="trip-card-heading">{t("tripCoupons")}</div>

              <div className="row g-3">
                {data.coupons.map((coupon, index) => (
                  <div className="col-12 col-md-6" key={index}>
                    <div className="trip-package-item">
                      <div className="d-flex justify-content-between">
                        <strong>{coupon.code}</strong>

                        <strong>
                          {coupon.discountValue}
                          {coupon.discountType === "Percentage"
                            ? "%"
                            : ` ${t("riyal")}`}
                        </strong>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>
                          {t("title")}: {coupon.title?.[lang]}
                        </span>

                        <span>
                          {t("discountType")}: {coupon.discountType}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between">
                        <span>
                          {t("startDate")}:{" "}
                          {coupon.startDate?.toDate?.() ?? coupon.startDate}
                        </span>

                        <span>
                          {t("endDate")}:{" "}
                          {coupon.endDate?.toDate?.() ?? coupon.endDate}
                        </span>
                      </div>

                      {coupon.description?.[lang] && (
                        <div className="mt-2">
                          <span>{coupon.description[lang]}</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <DeleteConfirmation t={t} handleDelete={handleDelete} />
    </section>
  );
};

export default TripDetails;
